import React from 'react'
import { redirectToCore } from '@helpers'
import { useClassroomEnv } from '@components/ClassroomEnv'
import { Logo, Text } from '@components/UI'
import { Classroom as ClassroomConstants } from '@constants'
import { useRecordingState } from '@components/Recording/hooks'

import { useClassroom, useClassroomQuery } from '../../hooks'
import UserDropdown from './UserDropdown'
import Tools from './Tools'
import ParticipantsCointainer from './ParticipantsContainer'

const Header = ({ step, panels, showParticipantsContainer }) => {
  const { env } = useClassroomEnv()
  const { data: classroom } = useClassroomQuery()
  const participants = Object.keys(classroom.participants || {}).reduce(
    (acc, key) => [...acc, { id: key, ...classroom.participants[key] }],
    []
  )

  return (
    <div className='gp-classroom-header classroom authenticated transparent'>
      <div
        className='logo'
        onClick={() => {
          redirectToCore('/')
        }}
      >
        <div className='default'>
          <Logo theme='light' />
        </div>
      </div>
      <div className='main'>
        {(step === ClassroomConstants.STEPS.FETCHING ||
          step === ClassroomConstants.STEPS.ONBOARDING ||
          step === ClassroomConstants.STEPS.CLOSED ||
          step === ClassroomConstants.STEPS.NOT_OPENED) && (
          <Text
            style={{
              color: 'rgba(255, 255, 255, .85)',
              flex: 1,
              textAlign: 'center'
            }}
          >
            {env === ClassroomConstants.ENV.CLASSROOM ? (
              <>
                Joining to a lesson with{' '}
                <font
                  style={{ color: 'rgba(255, 255, 255, 1)' }}
                  className='semibold'
                >
                  {participants.reduce(
                    (acc, value, index) =>
                      acc +
                      value.name +
                      (index === participants.length - 1 ? '' : ', '),
                    ''
                  )}
                </font>
              </>
            ) : null}
          </Text>
        )}
        {step === ClassroomConstants.STEPS.READY && <Tools panels={panels} />}
        {step === ClassroomConstants.STEPS.COMPLETED && (
          <Text
            style={{
              color: 'rgba(255, 255, 255, .85)',
              flex: 1,
              textAlign: 'center'
            }}
          >
            Session has ended
          </Text>
        )}

        {showParticipantsContainer && <ParticipantsCointainer step={step} />}

        <div
          style={{
            paddingLeft: '32px',
            height: '100%',
            display: 'flex',
            alignItems: 'center'
          }}
        >
          <UserDropdown />
        </div>
      </div>
    </div>
  )
}

const ClassroomHeader = () => {
  const [{ panels, step }] = useClassroom()
  return <Header step={step} panels={panels} showParticipantsContainer />
}

const PlayGroundHeader = () => {
  const [{ panels, step }] = useClassroom()
  return <Header step={step} panels={panels} />
}

const RecordingHeader = () => {
  const { panels, step } = useRecordingState()

  return <Header step={step} panels={panels} />
}

const HeaderWrapper = () => {
  const { env } = useClassroomEnv()

  switch (env) {
    case ClassroomConstants.ENV.PLAYGROUND:
      return <PlayGroundHeader />
    case ClassroomConstants.ENV.CLASSROOM:
      return <ClassroomHeader />
    case ClassroomConstants.ENV.RECORDING:
      return <RecordingHeader />
    default:
      return null
  }
}

export default HeaderWrapper
